import React from "react";
import { Link } from "react-router-dom";
import { toAbsoluteUrl } from "../../../helpers";

export function Brand() {
  return (
    <>
      <div
        className={`aside-brand d-flex flex-column align-items-center flex-column-auto py-5 py-lg-12`}
      >
        <Link to="" className="">
          <img
            alt="logo"
            src={toAbsoluteUrl("/images/logo.jpeg")}
            className="max-h-30px"
          />
        </Link>
      </div>
    </>
  );
}
